import React from "react";
import "./css/HowSkitterbookWorks.css";

export const HowSkitterbookWorks: React.FC = () => {
    return (
        <div className="how-container">
            <p className="how-text">
                Skitterbook takes your video and breaks it down into its individual
                frames, turning motion into a sequence of still images. These images are
                stored securely and privately — even the developer cannot view or access
                your content.
            </p>

            <p className="how-text">
                To keep the experience fast and responsive, Skitterbook reduces the
                resolution of each frame. Flickbooks don’t require high‑resolution
                imagery, and this optimisation ensures smooth playback and efficient
                editing without compromising the creative intent.
            </p>

            <p className="how-text">
                The interface has been designed to stay out of your way. Every control
                is intentional, helping you move quickly from video to flipbook with a
                workflow that feels simple, direct, and enjoyable.
            </p>

            <p className="how-text">
                Once your frames are ready, you can print them and assemble your own
                physical skitterbook. At the moment this relies on your own crafting
                skills, but our long‑term aim is to let you send your creations to
                professional fabricators so you can receive beautifully finished
                skitterbooks without the manual work.
            </p>
        </div>
    );
};

export default HowSkitterbookWorks;
